import * as React from 'react';

const CheckmarkShieldOutline16 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m7.34 8.3 3.56-3.58 1.07 1-4.62 4.67-2.89-2.82 1.06-1Zm7.33-5.9V8c0 5.6-6.67 8-6.67 8s-6.67-2.4-6.67-8V2.4L8 0Zm-1.5 1.05L8 1.59 2.83 3.45V8a6.31 6.31 0 0 0 2.76 4.92 13 13 0 0 0 2 1.28l.37.17.37-.17a13 13 0 0 0 2-1.28A6.31 6.31 0 0 0 13.17 8Z" }));
CheckmarkShieldOutline16.Size = 16;
CheckmarkShieldOutline16.Title = "CheckmarkShieldOutline";

export { CheckmarkShieldOutline16 as default };
